import { CALL_API } from 'redux-api-middleware'
import {
  LOAD_INFO_DASHBOARD_REQUEST,
  LOAD_INFO_DASHBOARD_SUCCESS,
  LOAD_INFO_DASHBOARD_FAILURE,
  ACTIVE_COURSE_REQUEST,
  ACTIVE_COURSE_SUCCESS,
  ACTIVE_COURSE_FAILURE,
  LOAD_BANNER_DASHBOARD_SUCCESS,
  LOAD_PRICE_LIST_REQUEST,
  LOAD_PRICE_LIST_SUCCESS,
  LOAD_PRICE_LIST_FAILURE,
} from './types'

import {
  DASHBOARD_EP,
  ACTIVE_EP,
  PRICE_LIST_EP,
} from '../constant'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadPriceList = () => {
  return {
    [CALL_API]: {
      endpoint: PRICE_LIST_EP,
      method: 'GET',
      headers,
      types: [
        LOAD_PRICE_LIST_REQUEST, LOAD_PRICE_LIST_SUCCESS, LOAD_PRICE_LIST_FAILURE,
      ],
    },
  }
}

export const loadBanner = () => {
  return {
    type: LOAD_BANNER_DASHBOARD_SUCCESS,
    payload: {
      banners: [
        {
          bannerImage: 'https://www.udemy.com/staticx/udemy/js/webpack/header-image.2e4c85972dcf8f3b2e0b900aceca3e4f.png',
          // buttonName: token !== '' ? 'UPGRADE TO INSTRUCTOR' : 'SIGN UP FOR FREE',
          // content: 'ถ้าคุณมีความรู้ และอยากแบ่งปัน ก็มีคอร์สออนไลน์ของตัวเองได้กับ Deknerd สร้างคอร์สออนไลน์ในรูปแบบวิดีโอ\nเพื่อเชื่อมต่อกับนักเรียนทั่วประเทศผ่าน www.deknerd.com',
          // title: 'เชื่อมต่อนักเรียนทั่วประเทศ',
          // url: token !== '' ? 'http://www.deknerd.com:8000/instructor/verify' : 'http://www.deknerd.com:8000/instructor/signup',
          // dataX: 'left',
          // dataY: 'center',
          // textAlign: 'tp-caption sl-content align-left',
        },
      ],
    },
  }
}

export const loadDashboard = (page, limit) => {
  return {
    [CALL_API]: {
      endpoint: DASHBOARD_EP(page, limit),
      method: 'GET',
      headers,
      types: [
        LOAD_INFO_DASHBOARD_REQUEST, LOAD_INFO_DASHBOARD_SUCCESS, LOAD_INFO_DASHBOARD_FAILURE,
      ],
    },
  }
}

export const activeCourse = (id) => {
  return {
    [CALL_API]: {
      endpoint: ACTIVE_EP(id),
      method: 'PUT',
      headers,
      types: [
        ACTIVE_COURSE_REQUEST, ACTIVE_COURSE_SUCCESS, ACTIVE_COURSE_FAILURE,
      ],
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/instructor.js